document.addEventListener("DOMContentLoaded", function () {
    const lottieElements = document.querySelectorAll(".rtb-lottie");

    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    if (isMobile) return;

    lottieElements.forEach(el => {
        el.addEventListener("mouseenter", function () {
            el.stop();
            el.play();
        });
    });
});

